import styled, { keyframes } from 'styled-components';
import { theme } from '../../styles/config/theme';
import { rgba } from 'polished';
import media from '../../styles/config/mediaQueries';

const fadeInSwiper = keyframes`
  0%{
    opacity: 0;
    transform: translateZ(-80px);
  }
  100% {
    transform: translateZ(0);
    opacity: 1;
  };
`;

const fadeInContainer = keyframes`
  from{ opacity: 0 }
  to { opacity: 1 }
`;

const StyledContainer = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
  background-color: ${rgba(theme.color.black, 0.83)};
  animation: ${fadeInContainer} 0.4s ease-in-out forwards;
  perspective: 1000px;
  z-index: 10;

  .swiper {
    width: 100%;
    height: 100%;
    padding: 0;
    animation: ${fadeInSwiper} 0.5s ease-in-out forwards;
  }
`;

const StyledSlide = styled.div`
  width: 100%;
  height: 100%;
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
  background-image: url('${props => props.backgroundUrl}');
`;

const StyledImage = styled.img`
  height: 100%;
  margin: 0 auto;
`;

const StyledCloseButton = styled.button`
  position: fixed;
  top: 26px;
  width: 36px;
  height: 36px;
  z-index: 2;

  svg {
    width: 100%;
  }
  ${media.mobile`
    right: 26px;
  `}
  ${media.desktop`
    right: 45px;
  `}
`;

export { StyledContainer, StyledSlide, StyledImage, StyledCloseButton };
